var styles = [".unauthorized[_ngcontent-%COMP%]   clr-icon[_ngcontent-%COMP%]{color:#ff681c}"];
export { styles as styles };
